(async () => {
  const el = document.getElementById('doctor-registration-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */'src/pages/info/doctor-about/index.vue'),
    },
  ]

  await clientRender({ components })
})()
